<template>
    <div class="row">
        <div class="col-md-12 tw-mb-3">
            <div class="tw-mb-8">
                <p class="tw-text-sm tw-m-0">
                    {{
                        translate(
                            "Please enter the OTP code to finish the account re-activation process.",
                            "အကောင့်ပြန်လည်အသုံးပြုနိုင်ရန် OTP ကုဒ်ဖြည့်သွင်းပါ။"
                        )
                    }}
                </p>
                <p class="tw-mb-3 tw-text-sm" v-text="otp.otp_text"></p>
                <p class="tw-m-0 tw-text-sm tw-text-slate-500">
                    {{
                        translate(
                            "If you don't received or expired OTP",
                            "OTP ကုဒ်မရရှိပါက"
                        )
                    }}
                    -
                    <span
                        v-if="otp.otp_interval > 0"
                        class="tw-text-main-color/60 tw-cursor-not-allowed"
                        >{{ __("chat.resend") }}
                        <span v-text="otp.countdown_text"></span
                    ></span>
                    <span
                        class="tw-text-main-color tw-cursor-pointer"
                        v-if="otp.show_resent"
                        @click="onResendOtp"
                        >{{ __("chat.resend") }}</span
                    >
                </p>
            </div>
            <div class="tw-w-full">
                <div class="col-md-12 tw-mb-3">
                    <div
                        class="tw-leading-none tw-mb-3 tw-bg-red-50 dark:tw-bg-slate-700 tw-rounded-lg tw-p-2 tw-py-3 tw-flex tw-items-center"
                        v-if="error_message.length > 0"
                    >
                        <i
                            class="fas fa-exclamation-triangle tw-text-red-500 tw-text-md tw-ml-2 tw-mr-2"
                        ></i>
                        <span
                            class="tw-text-sm tw-text-red-600"
                            v-text="error_message"
                        ></span>
                    </div>
                </div>
                <div class="col-md-12 tw-text-center">
                    <input
                        type="text"
                        class="form-control tw-p-2 tw-text-center tw-tracking-[15px] tw-rounded-lg placeholder:tw-tracking-normal"
                        @keypress="otpInputValidate"
                        v-model="otp.form.otp_code"
                        placeholder="Enter 6 Digit Code"
                        @focus="input_errors.otp_code = ''"
                    />
                    <span
                        class="tw-text-red-500 tw-text-xs"
                        v-if="input_errors.otp_code"
                        v-text="input_errors.otp_code[0]"
                    ></span>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <button
                @click.prevent="onActivate"
                :disabled="activating"
                class="btn tw-w-full tw-p-2 tw-bg-main-color tw-rounded-lg tw-text-white"
            >
                <BeatLoader
                    v-if="activating"
                    :loading="activating"
                    color="white"
                    size="7px"
                    class="tw-pt-[3px]"
                ></BeatLoader>
                <span v-else>Verify</span>
            </button>
            <div class="tw-mt-3 tw-text-center">
                <span
                    @click.prevent="viewLoginForm('chat_login')"
                    class="tw-cursor-pointer hover:tw-underline tw-text-main-color tw-text-sm"
                    >Back to Login</span
                >
            </div>
        </div>
    </div>
</template>
<script>
import { resendOtp, activate } from "@landing/Services/auth_service";
import { generalStore } from "@landing/Stores/general_store";
import BeatLoader from "vue-spinner/src/BeatLoader.vue";

export default {
    components: { BeatLoader },
    data() {
        return {
            generalStore: generalStore(),
            input_errors: {},
            activating: false,
            error_message: "",
            otp: {
                form: {
                    type: "",
                    value: "",
                    otp_code: "",
                },
                otp_text: "",
                otp_interval: 0,
                countdown_text: "",
                intervalHandle: null,
                show_resent: false,
            },
        };
    },
    mounted() {
        if (this.generalStore.get_form_options) {
            const data = this.generalStore.get_form_options;
            this.otp.form.type = data.type;
            this.otp.form.value = data.value;
            this.otp.otp_text = data.otp_text;
            this.otp.otp_interval = data.otp_interval;
            this.startCountDown();
        }
    },
    methods: {
        viewLoginForm(val) {
            this.generalStore.setActiveLoginForm(val);
        },
        onResendOtp() {
            resendOtp({ phone: this.otp.form.value }).then((data) => {
                if (data.status == 422) {
                    this.error_message = "";
                    this.input_errors = data.data.errors;
                } else if (data.status != 200) {
                    this.error_message = this.__("chat.something_wrong");
                } else if (data.status == 200) {
                    this.error_message = "";
                    if (data.data.result == 1) {
                        this.otp.form.type = data.data.type;
                        this.otp.form.value = data.data.value;
                        this.otp.otp_text = data.data.otp_text;
                        this.otp.otp_interval = data.data.otp_interval;
                        this.startCountDown();
                        Vue.$toast.success(
                            this.translate(
                                "Successfully resend OTP code.",
                                "အောင်မြင်စွာ OTP ကုဒ် ပြန်ပို့ပေးလိုက်ပါပြီ"
                            )
                        );
                    } else {
                        this.error_message = data.data.message;
                    }
                }
            });
        },
        onActivate() {
            this.activating = true;
            activate(this.otp.form).then((data) => {
                if (data.status == 422) {
                    this.error_message = "";
                    this.input_errors = data.data.errors;
                } else if (data.status != 200 && data.status != 422) {
                    this.input_errors = {};
                    this.error_message = "Oops! Something went wrong.";
                } else if (data.status == 200) {
                    this.input_errors = {};
                    this.error_message = "";
                    if (data.data.result == 1) {
                        Vue.$toast.success(data.data.message);
                        setTimeout(() => {
                            window.location.reload();
                        }, 500);
                    } else {
                        this.error_message = data.data.message;
                    }
                }

                setTimeout(() => {
                    this.activating = false;
                }, 500);
            });
        },
        otpInputValidate(evt) {
            var theEvent = evt || window.event;

            if (theEvent.code == "Enter") {
                return;
            }

            if (this.otp.form.otp_code.length >= 6) {
                theEvent.returnValue = false;
                if (theEvent.preventDefault) theEvent.preventDefault();
            }

            // Handle paste
            if (theEvent.type === "paste") {
                key = event.clipboardData.getData("text/plain");
            } else {
                // Handle key press
                var key = theEvent.keyCode || theEvent.which;
                key = String.fromCharCode(key);
            }
            var regex = /[0-9]|\./;
            if (!regex.test(key)) {
                theEvent.returnValue = false;
                if (theEvent.preventDefault) theEvent.preventDefault();
            }
        },
        tick() {
            // turn the seconds into mm:ss
            var min = Math.floor(this.otp.otp_interval / 60);
            var sec = this.otp.otp_interval - min * 60;

            //add a leading zero (as a string value) if seconds less than 10
            if (sec < 10) {
                sec = "0" + sec;
            }

            // concatenate with colon
            this.otp.countdown_text = "( " + min.toString() + ":" + sec + " )";

            // stop is down to zero
            if (this.otp.otp_interval === 0) {
                this.otp.show_resent = true;
                this.otp.countdown_text = "";
                clearInterval(this.otp.intervalHandle);
                return;
            }

            //subtract from seconds remaining
            this.otp.otp_interval--;
        },
        startCountDown() {
            if (this.otp.otp_interval > 0) {
                this.otp.show_resent = false;

                this.otp.intervalHandle = setInterval(() => {
                    this.tick();
                }, 1000);
            } else {
                this.otp.countdown_text = "";
                this.otp.show_resent = true;
            }
        },
    },
};
</script>
